"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractPaginatedBank = void 0;
const AbstractBatcherBank_1 = require("./AbstractBatcherBank");
const _ = require("lodash");
class AbstractPaginatedBank extends AbstractBatcherBank_1.AbstractBatcherBank {
    async fetchCollection(event) {
        const res = this.fetchPaginated(event);
        let found = [];
        for await (let i of res) {
            const items = this.transform(i);
            found.push(...items.map((i) => this.generateIDFromData(i)));
            event.apply(items === null || items === void 0 ? void 0 : items.reduce((prev, cur) => {
                return {
                    ...prev,
                    [cur.id]: cur
                };
            }, {}));
        }
        // may not have found some
        _.difference(event.items.map((i) => this.generateID(i)), found).forEach((i) => {
            event.notFound(i);
        });
    }
}
exports.AbstractPaginatedBank = AbstractPaginatedBank;
